<template>
  <el-container class="box">
    <header class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <el-form ref="searchForm" :inline="true" label-width="10px" :model="listQuery" size="small">
        <el-form-item>
          <el-input v-model="listQuery.keyword" @input="getpatientList" clearable class="inputwidth"
            placeholder="请输入搜索内容" />
        </el-form-item>
        <el-form-item>
          <el-cascader v-model="listQuery.roleId" @change="getpatientList" :options="roleData" clearable
            :props="defaultPropsMenu1" :show-all-levels="false"></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-select v-model="updateTimetype" clearable class="selectinput" @change="timeChange" placeholder="请选择更新时间">
            <el-option v-for="(item,index) in timeArr" :key="index" :label="item.label" value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="listQuery.updateTime" @change="getpatientList" type="daterange"
            value-format="yyyy-MM-dd" format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="listQuery.disabled" @change="getpatientList" clearable class="selectinput"
            placeholder="请选择状态">
            <el-option v-for="(item,index) in statusArr" :key="index" :label="item.label" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getpatientList">搜索</el-button>
          <el-button type="success" @click="addColumn">新增</el-button>
        </el-form-item>
      </el-form>
    </header>
    <el-main class="table-box">
      <el-table :data="columnList" :header-cell-style="{background:'rgba(133, 182, 249)',color:'#ffffff'}"
        tooltip-effect="dark" ref="multipleTable" fit highlight-current-row>

        <el-table-column align="center" label="序号" width="50" fixed="left">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="栏目代码">
          <template slot-scope="scope">
            {{ scope.row.code }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="栏目名称">
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="软件端">
          <template slot-scope="scope">
            {{clientTypeMap[scope.row.clientType]  }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            {{ scope.row.disabled?"停用":"启用" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="允许角色">
          <template slot-scope="scope">
            {{ scope.row.roleNames }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="创建人">
          <template slot-scope="scope">
            {{ scope.row.createUserId }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="创建时间" width="167">
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="更新人">
          <template slot-scope="scope">
            {{ scope.row.updateUserId }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="更新时间">
          <template slot-scope="scope">
            {{ scope.row.updateTime }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="内容说明">
          <template slot-scope="scope">
            <div class="description"> {{ scope.row.description }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="look(scope.row)">详情</el-button>
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
            <el-button type="text" v-if="!scope.row.disabled" @click="disableColumn(scope.row)">停用</el-button>
            <el-button type="text" v-if="scope.row.disabled" @click="enableColumn(scope.row)">启用</el-button>
            <el-button type="text" @click="deleteColumn(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination background :current-page="listQuery.current" :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.size" layout="total, sizes, prev, pager, next, jumper" :total="total"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </el-main>
    <!-- 新增修改弹框   -->
    <el-dialog :title="titles[dialogStatus]" :visible.sync="dialogVisible" center width="60%"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="temp" ref="dataForm" label-width="110px" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="栏目名称：" prop="name">
              <el-input placeholder="请输入栏目名称" class="inputwidth" v-model="temp.name" clearable
                :disabled="dialogStatus === 'look' ? true : false"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="栏目代码：" prop="code">
              <el-input placeholder="请输入栏目代码" class="inputwidth" v-model="temp.code" clearable
                :disabled="dialogStatus === 'look' ? true : false"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="功能脚本：" prop="script">
              <el-input placeholder="请输入功能脚本" class="inputwidth" v-model="temp.script" clearable
                :disabled="dialogStatus === 'look' ? true : false"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="栏目状态：" prop="disabled">
              <el-radio-group v-model="temp.disabled" :disabled="dialogStatus === 'look' ? true : false">
                <el-radio :label="0">启用</el-radio>
                <el-radio :label="1">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="归属软件端：" prop="clientType">
              <el-select placeholder="请选择归属软件端" class="selectwidth" v-model="temp.clientType"
                :disabled="dialogStatus === 'look' ? true : false">
                <el-option v-for="(item,index ) in clientTypeArr" :key="index" :label="item.label"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="说明：" prop="description">
              <el-input placeholder="请输入说明" type="textarea" class="inputwidth" v-model="temp.description" clearable
                :disabled="dialogStatus === 'look' ? true : false"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="允许角色：" prop="roleIds">
              <el-tree :data="roleData" show-checkbox :disabled="dialogStatus === 'look' ? true : false" node-key="id"
                :default-expanded-keys="expankeys" :default-checked-keys="defachecked" :props="defaultPropsMenu"
                @check-change="handleCheckChange" ref="menuTree" check-strictly>
              </el-tree>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false">关闭</el-button>
        <el-button type="primary" @click="saveColumn" :disabled="dialogStatus === 'look' ? true : false">保存</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>
<script>
import { api_getperuserinfo } from "@/api/permissions";
import {
  addColumn,
  columnList,
  columnDetailed,
  editColumn,
  enableColumn,
  disableColumn,
  deleteColumn
} from "@/api/column";

export default {
  data() {
    let sectionUserPoListChecked = (rule, value, callback) => {
      if (this.temp.roleIds.length == 0) {
        return callback(new Error("请选择关联角色"));
      } else {
        callback();
      }
    };
    return {
      breadList: [{ name: "系统设置" }, { name: "内容栏目管理" }],
      listQuery: {
        size: 20,
        current: 1,
        disabled: "",
        roleId: "",
        updateTime: "",
        keyword: ""
      },
      temp: {
        name: "",
        code: "",
        script: "",
        disabled: "",
        clientType: "",
        description: "",
        id: "",
        roleIds: []
      },
      rules: {
        name: [
          {
            required: true,
            message: "必须输入栏目名称",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "必须输入栏目代码",
            trigger: "blur"
          }
        ],
        script: [
          {
            required: true,
            message: "必须输入功能脚本",
            trigger: "blur"
          }
        ],
        disabled: [
          {
            required: true,
            message: "必须选择栏目状态",
            trigger: "change"
          }
        ],
        clientType: [
          {
            required: true,
            message: "必须选择归属软件端",
            trigger: "change"
          }
        ],
        description: [
          {
            required: true,
            message: "必须输入说明",
            trigger: "blur"
          }
        ],
        roleIds: [
          {
            required: true,
            message: "必须选择关联角色",
            validator: sectionUserPoListChecked,
            trigger: "change"
          }
        ]
      },
      roleArr: ["病人", "医护", "疗程管理"],
      timeArr: [
        {
          label: "当天",
          id: 1
        },
        {
          label: "3天内",
          id: 2
        },
        {
          label: "7天内",
          id: 3
        },
        {
          label: "全部",
          id: 4
        }
      ],
      statusArr: [
        {
          label: "启用",
          id: 0
        },
        {
          label: "停用",
          id: 1
        }
      ],
      dateTime: "",
      patientList: [],
      total: 0,
      dialogVisible: false,
      titles: {
        add: "新增栏目",
        edit: "编辑栏目",
        look: "查看详情"
      },
      dialogStatus: "add",
      clientTypeArr: [
        {
          label: "病人端",
          id: 1
        },
        {
          label: "医护端",
          id: 2
        },
        {
          label: "后台管理端",
          id: 3
        },
        {
          label: "IM对话",
          id: 4
        }
      ],
      defaultPropsMenu1: {
        children: "children",
        label: "name",
        value: "id",
        emitPath: false
      },
      defaultPropsMenu: {
        children: "children",
        label: "name"
      }, //改变权限树名字显示字段
      expankeys: [], //权限树默认展开数组
      defachecked: [], //权限树默认选中数组
      roleData: null,
      updateTimetype: "",
      columnList: [],
      clientTypeMap: {
        1: "病人端",
        2: "医护端",
        3: "后台管理端",
        4: "IM对话"
      }
    };
  },
  mounted() {
    this.getrolesrouce();
    this.getpatientList();
  },
  methods: {
    timeChange() {
      if (this.updateTimetype == 1) {
        this.listQuery.updateTime = [this.getDay(0), this.getDay(0)];
      } else if (this.updateTimetype == 2) {
        this.listQuery.updateTime = [this.getDay(0), this.getDay(3)];
      } else if (this.updateTimetype == 3) {
        this.listQuery.updateTime = [this.getDay(0), this.getDay(7)];
      } else if (this.updateTimetype == 4) {
        this.listQuery.updateTime = [];
      }
      this.getpatientList();
    },
    handleCheckChange() {
      let checkedTreeData = this.$refs.menuTree.getCheckedNodes();
      this.temp.roleIds.length = checkedTreeData.length;
    },
    getDay(day) {
      let today = new Date();

      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;

      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      let tYear = today.getFullYear();

      let tMonth = today.getMonth();

      let tDate = today.getDate();

      tMonth = this.doHandleMonth(tMonth + 1);

      tDate = this.doHandleMonth(tDate);

      return tYear + "-" + tMonth + "-" + tDate;
    },

    doHandleMonth(month) {
      let m = month;

      if (month.toString().length == 1) {
        m = "0" + month;
      }

      return m;
    },
    async getrolesrouce() {
      let res = await api_getperuserinfo();
      this.roleData = res.data;
    },
    handleSizeChange(val) {
      this.listQuery.size = val;
      this.getpatientList();
    },
    handleCurrentChange(val) {
      this.listQuery.current = val;
      this.getpatientList();
    },
    addColumn() {
      this.dialogVisible = true;
      this.dialogStatus = "add";
      this.temp.id = "";
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].resetFields();
      }
      if (this.$refs.menuTree) {
        this.$refs.menuTree.setCheckedKeys([]);
      }
    },
    handleDialogClose() {
      this.$refs["dataForm"].clearValidate(); // 清除整个表单的校验
      this.$refs["dataForm"].resetFields();
    },
    saveColumn() {
      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          let resarr = this.$refs.menuTree.getCheckedNodes();
          this.temp.roleIds = [];
          resarr.forEach(item => {
            this.temp.roleIds.push(item.id);
          });
          if (this.dialogStatus == "add") {
            let res = await addColumn(this.temp);
            if (res.code == 0) {
              this.$message({
                message: "新增成功",
                type: "success"
              });
              this.handleDialogClose();
              this.$refs.menuTree.setCheckedKeys([]);
              this.dialogVisible = false;
              await this.getpatientList();
            } else {
              this.$message.error(res.message);
            }
          } else if (this.dialogStatus == "edit") {
            let res = await editColumn(this.temp);
            if (res.code == 0) {
              this.$message({
                message: "修改成功",
                type: "success"
              });
              this.handleDialogClose();
              this.$refs.menuTree.setCheckedKeys([]);
              this.dialogVisible = false;
              await this.getpatientList();
            } else {
              this.$message.error(res.message);
            }
          }
        }
      });
    },
    async getpatientList() {
      this.listQuery.updateStartTime = this.listQuery.updateTime
        ? this.listQuery.updateTime[0] + " " + "00:00:00"
        : "";
      this.listQuery.updateEndTime = this.listQuery.updateTime
        ? this.listQuery.updateTime[1] + " " + "23:59:59"
        : "";
      let res = await columnList(this.listQuery);
      this.columnList = res.data.records;
      this.total = res.data.total;
    },
    async look(row) {
      this.dialogVisible = true;
      this.dialogStatus = "look";

      let res = await columnDetailed({ id: row.id });
      this.$refs.menuTree.setCheckedKeys([]);
      this.defachecked = res.data.roleIds;
      this.expankeys = res.data.roleIds;
      this.temp = {
        name: res.data.name,
        code: res.data.code,
        script: res.data.script,
        disabled: res.data.disabled ? 1 : 0,
        clientType: res.data.clientType,
        description: res.data.description,
        roleIds: res.data.roleIds
      };
    },
    async edit(row) {
      this.dialogVisible = true;
      this.dialogStatus = "edit";
      let res = await columnDetailed({ id: row.id });
      this.$refs.menuTree.setCheckedKeys([]);
      this.defachecked = res.data.roleIds;
      this.expankeys = res.data.roleIds;
      this.temp = {
        name: res.data.name,
        code: res.data.code,
        script: res.data.script,
        disabled: res.data.disabled ? 1 : 0,
        clientType: res.data.clientType,
        description: res.data.description,
        roleIds: res.data.roleIds,
        id: res.data.id
      };
    },
    //停用
    async disableColumn(row) {
      let res = await disableColumn({ id: row.id });
      if (res.code == 0) {
        this.$message({
          message: "停用成功",
          type: "success"
        });
        await this.getpatientList();
      }
    },
    //启用
    async enableColumn(row) {
      let res = await enableColumn({ id: row.id });
      if (res.code == 0) {
        this.$message({
          message: "启用成功",
          type: "success"
        });
        await this.getpatientList();
      }
    },
    deleteColumn(row) {
      this.$confirm("是否要删除该栏目", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      }).then(async () => {
        let res = await deleteColumn({ id: row.id });
        if (res.code == 0) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          await this.getpatientList();
        }
      });
    }
  }
};
</script>


<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.table-box {
  background: #fff;
  padding: 20px;
  margin: 0 16px;
}
.flexs {
  display: flex;
  flex-wrap: wrap;
}
.selectwidth {
  width: 100%;
}

.pagination-container {
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.description {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
/deep/ .el-tree {
  padding-top: 15px;
  padding-left: 10px;
  // 不可全选样式
  .el-tree-node {
    .is-leaf + .el-checkbox .el-checkbox__inner {
      display: inline-block;
    }

    .el-checkbox .el-checkbox__inner {
      display: none;
    }
  }
}

/deep/ .el-table--small th {
  background: #fafafa;
  border: none;
}
/deep/.el-table--border {
  border: none;
}
/deep/.el-table--border th {
  border: none;
  text-align: center;
  color: #333333;
  //   border-bottom: 1px solid #e9e9e9;
}
/deep/.el-table--border td {
  border-right: none;
  text-align: center;
  color: #333333;
  padding: 10.5px 0;
  border-bottom: 1px solid #e9e9e9;
}
</style>
